import { AsyncAutosuggest } from 'components';
import React from 'react';

const ClubAutosuggest = ({
	value,
	name = 'club_id',
	label,
	position,
	handleChange,
	...props
}) => (
	<AsyncAutosuggest
		name={name}
		label={label}
		value={value}
		position={position}
		displayField="name"
		remoteUrl="/api/v1/admin/clubs"
		placeholder="Select club"
		handleChange={handleChange}
	/>
);

export default ClubAutosuggest;
